import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 共享数据
    message: null,
    count: 0,
    windowWidth: window.innerWidth, // 初始化窗口宽度
    loginShow: false, // 控制登录弹窗显示
  },
  modules: {
    user,
  },
  getters,
  mutations: {
    // 同步修改 state
    SET_MESSAGE(state, payload) {
      state.message = payload;
    },
    INCREMENT_COUNT(state) {
      state.count++;
    },
    // 新增这个 Mutation
    SET_WINDOW_WIDTH: (state, width) => {
      state.windowWidth = width;
    },
    // 控制登录弹窗显示
    SET_LOGIN_SHOW: (state, show) => {
      state.loginShow = show;
    },
  },
  actions: {
    // 异步操作（如 API 请求）
    updateMessage({ commit }, newMessage) {
      commit("SET_MESSAGE", newMessage);
    },
    incrementCount({ commit }) {
      commit("INCREMENT_COUNT");
    },
  },
});

export default store;
